import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { formatters } from '@morpho-org/ui-v6/utils';
import { useCallback, useMemo } from 'react';
import { POSITION_MANAGER_DIALOG_OPTIONS } from '@/components/common/PositionManager/dialogOptions';
import { PositionManagerBorrowDialog } from '@/components/common/PositionManager/PositionManagerBorrowDialog';
import { PositionManagerRepayDialog } from '@/components/common/PositionManager/PositionManagerRepayDialog';
import { useChainNavigation } from '@/hooks/useChainNavigation';
interface UseBorrowCardInput {
  marketId: MarketId;
  loan: {
    token: InterfaceToken;
  };
  lltv: number | bigint;
}
export const useBorrowCard = t0 => {
  const $ = _c(17);
  const {
    marketId,
    loan,
    lltv
  } = t0;
  const {
    toggleDialog
  } = useDialogContext();
  let t1;
  if ($[0] !== loan.token.chain.id) {
    t1 = {
      chainId: loan.token.chain.id
    };
    $[0] = loan.token.chain.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    syncChainSwitch
  } = useChainNavigation(t1);
  let t2;
  if ($[2] !== lltv) {
    bb0: {
      const formatter = formatters.percent.digits(2).trailingZero(false).unit("%");
      if (typeof lltv === "bigint") {
        t2 = formatter.of(lltv, 18);
        break bb0;
      }
      t2 = formatter.of(safeParseNumber(lltv), 18);
    }
    $[2] = lltv;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formattedLltv = t2;
  let t3;
  if ($[4] !== loan.token.chain.id || $[5] !== marketId || $[6] !== syncChainSwitch || $[7] !== toggleDialog) {
    t3 = () => {
      syncChainSwitch();
      toggleDialog(<PositionManagerBorrowDialog marketId={marketId} chainId={loan.token.chain.id} onClose={() => toggleDialog(false)} />, {
        ...POSITION_MANAGER_DIALOG_OPTIONS,
        fullSize: true
      });
    };
    $[4] = loan.token.chain.id;
    $[5] = marketId;
    $[6] = syncChainSwitch;
    $[7] = toggleDialog;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onBorrowClick = t3;
  let t4;
  if ($[9] !== marketId || $[10] !== syncChainSwitch || $[11] !== toggleDialog) {
    t4 = () => {
      syncChainSwitch();
      toggleDialog(<PositionManagerRepayDialog marketId={marketId} onClose={() => toggleDialog(false)} />, {
        ...POSITION_MANAGER_DIALOG_OPTIONS,
        fullSize: true
      });
    };
    $[9] = marketId;
    $[10] = syncChainSwitch;
    $[11] = toggleDialog;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const onRepayClick = t4;
  let t5;
  if ($[13] !== formattedLltv || $[14] !== onBorrowClick || $[15] !== onRepayClick) {
    t5 = {
      formattedLltv,
      onBorrowClick,
      onRepayClick
    };
    $[13] = formattedLltv;
    $[14] = onBorrowClick;
    $[15] = onRepayClick;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};